import { ref, watch } from 'vue';

export function usePastEventsToggle(activeRange, { initialValue = false, onReset, onToggle } = {}) {
  const showPastEvents = ref(initialValue);

  watch(
    activeRange,
    () => {
      showPastEvents.value = false;
      onReset?.();
    },
    { deep: true }
  );

  const togglePastEvents = () => {
    showPastEvents.value = !showPastEvents.value;
    onToggle?.(showPastEvents.value);
  };

  return {
    showPastEvents,
    togglePastEvents,
  };
}
